<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <pre>
    <code>
    {{ JSON.stringify(data, null, 2) }}
    </code>
    </pre>
    </div>
</template>
<script>
import gql from 'graphql-tag'

import { useQuery } from '@vue/apollo-composable'

const EXPORT_DATA_QUERY = gql`
    query ExportData {
        areas(limit: 20000, offset: 0) {
            id
            tag
            tagEn
            isVisible
        }
        skills(limit: 20000, offset: 0) {
            id
            tag
            tagEn
            isVisible
        }
        users(limit: 20000) {
            nativeId
            id
            facebookId
            firstName
            middleName
            lastName
            job
            intro
            status
            facebookUrl
            twitterUrl
            instagramUrl
            operatorComment
            createdAt
            updatedAt
            profilePath
            area {
                id
                tagEn
                tag
            }
            skills {
                id
            }
            interests {
                id
            }
            givsReceived {
                id
            }
            givsGiven {
                id
            }
        }
        givs(limit: 20000) {
            id
            comment
            operatorComment
            kind
            status
            createdAt
            updatedAt
            giverId
            receiverId
        }
        wantSends(limit: 20000) {
            toUserId
            fromUserId
            createdAt
        }
        wantReceives(limit: 20000) {
            toUserId
            fromUserId
            createdAt
        }
        thanksCards(limit: 20000) {
            id
            title
            message
            createdAt
            updatedAt
            givId
            receiverId
        }
        thanksCardImages(limit: 20000) {
            id
            uuid
            mimeType
            path
            createdAt
            updatedAt
            userId
            thanksCardId
        }
        likes(limit: 20000) {
            id
            thanksCardId
            userId
        }
        comments(limit: 20000) {
            id
            uuid
            userId
            message
            isDeleted
            createdAt
            updatedAt
            thanksCardId
            parentCommentId
        }
        invitationCodes(limit: 20000) {
            id
            code
            memo
            expiresAt
            createdAt
            updatedAt
            userId
        }
    }
`
export default {
    setup() {
        const { result, error } = useQuery(EXPORT_DATA_QUERY)
        return {
            data: { result, error },
        }
    },
}
</script>
